import React, { useState } from 'react';

import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

import { useCookies } from 'react-cookie'
import { FaCheckCircle, FaCircle } from 'react-icons/fa';

const ModalCookies = () => {

    const [cookies, setCookie, removeCookie] = useCookies(['viewed_cookie_policy']);

    const [open, setOpen] = useState(cookies['viewed_cookie_policy'] == undefined && !(window.location.href.endsWith("/politica-de-cookies") || window.location.href.endsWith("/politica-de-cookies/")));
    const [moreInfo1, setMoreInfo1] = useState(false);

    const [openConfig, setOpenConfig] = useState(false);

    const [focusAfterClose, setFocusAfterClose] = useState(true);

    const handleSelectChange = ({ target: { value } }) => {
        setFocusAfterClose(JSON.parse(value));

        if (cookies['google_cookie_enabled'] == undefined) {
            setCookie('google_cookie_enabled', '1');
        }
    }
    const handleSelectCancel = ({ target: { value } }) => {
        setFocusAfterClose(JSON.parse(value));

    }

    window.document.removeEventListener("openCookiesDialog", () => { });
    window.document.addEventListener("openCookiesDialog", () => setOpen(true));

    return (
        <div>
            <style>
                {" .modal-dialog {display: flex; vertical-align: middle; justify-content: center; flex-direction: column; text-align: center; overflow: auto}"}
                {" .modal.fade.show {display: flex !important;}"}
            </style>
            <Modal returnFocusAfterClose={focusAfterClose} isOpen={open}>
                {!openConfig &&
                    <>
                        <ModalBody>
                            <div style={{ fontWight: "bold", fontSize: 25, color: "#fd8021", paddingTop: 13 }}>Valoramos su privacidad</div>
                            <br></br>
                        OIP utiliza cookies propias y de terceros, técnicas para garantizar el funcionamiento de la web, así como analíticas con la finalidad de analizar la navegación y el tráfico generado. 
                        Puede aceptar, rechazar o configurar la instalación de las cookies.
                        </ModalBody>

                        <ModalFooter>
                            <div style={{ display: "flex", flexDirection: "row", marginTop: 10, width: "calc(100% - 30px)" }}>
                                <Button className="Button-Modal-Back" color="outline-primary" style={{ marginRight: 15, flexGrow: 0 }} onClick={() => setOpenConfig(!openConfig)}>Configurar</Button>
                            <Button className="Button-Modal" style={{ flexGrow: 1 }} onClick={() => { setOpen(!open); setCookie('viewed_cookie_policy', 'ok'); if (cookies['google_cookie_enabled'] == undefined) setCookie('google_cookie_enabled', '1') }} value="true" type="select" id="focusAfterClose" onChange={handleSelectChange}>Aceptar todas</Button>
                            <Button className="Button-Modal" style={{ flexGrow: 1 }} style={{ marginLeft: 5 }} onClick={() => { setOpen(!open); }} value="false" type="select" id="focusAfterClose" onChange={handleSelectCancel}>Rechazar</Button>
                            </div>
                            <ModalBody>
                                 Para obtener más información visite nuestra <a href="/politica-de-cookies">Política de Cookies</a>
                            </ModalBody>
                        </ModalFooter>
                    </>
                }

                {openConfig &&
                    <>
                        <ModalBody>
                            <style>{" .modal-dialog {text-align: left;}"}</style>
                            <div style={{ fontWight: "bold", textAlign: "center", fontSize: 25, color: "#004085", paddingTop: 13 }}>Configuración</div>
                            <br></br>
                            <div style={{ textAlign: "center" }}>Politica de Privacidad</div>
                            <br></br>
                            El siguiente Panel de Configuración muestra las cookies que utiliza este sitio web y la finalidad para la que se utilizan.
                            <span style={{ display: (!moreInfo1 ? null : "none") }}>
                                ...
                                <br></br>
                                <div style={{ textDecoration: "underline" }} onClick={() => setMoreInfo1(!moreInfo1)}>{!moreInfo1 ? "Mostrar más" : "Ocultar"}</div>
                            </span>


                            <span style={{ display: (!moreInfo1 ? "none" : null) }}>
                                <br />
                                <br />
                            Excepto en el caso de las categorías de cookies que sean estrictamente necesarias para el funcionamiento de la página web, puedes aceptar o rechazar
                            la utilización de cookies para cada categoría de cookies, moviendo el selector que encontrarás al final de cada una de las líneas de abajo y pulsando
                            en “Guardar y salir”. Una vez hayas aceptado la utilización de determinadas categorías de cookies, podrás cambiar tu opción moviendo el selector que
                            se encuentra al final de la línea que corresponda. Asimismo, te informamos que, si pulsas en “Guardar y salir” sin haber seleccionado ninguna cookie,
                            equivaldrá al rechazo de todas las cookies no necesarias. Para más información consulte nuestra Política de Cookies.
                                <div style={{ textDecoration: "underline" }} onClick={() => setMoreInfo1(!moreInfo1)}>Ocultar</div>
                            </span>

                            <div>
                                <CookieCheck text={"Funcionamiento básico"} enabled={false} startValue={true} />
                                <CookieCheck text={"Google Analytics"} startValue={cookies["google_cookie_enabled"] == "1"} onChange={(varBool) => {
                                    setCookie('google_cookie_enabled', varBool ? '1' : '0');

                                    if (!varBool) {
                                        document.cookie = "_ga_R11ECE3ZFC=;expires = Thu, 01 Jan 1970 00:00:00 GMT";
                                        document.cookie = "_ga_K793H6QR7Q=;expires = Thu, 01 Jan 1970 00:00:00 GMT";
                                        document.cookie = "_ga_6Q054R5EJM=;expires = Thu, 01 Jan 1970 00:00:00 GMT";
                                        document.cookie = "_gid=;expires = Thu, 01 Jan 1970 00:00:00 GMT";
                                        document.cookie = "_ga=;expires = Thu, 01 Jan 1970 00:00:00 GMT";
                                    }
                                }} />
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <div style={{ display: "flex", flexDirection: "row", marginTop: 10, width: "calc(100% - 30px)" }}>
                                <Button className="Button-Modal-Back" color="outline-primary" style={{ marginRight: 15, flexGrow: 0 }} onClick={() => setOpenConfig(!openConfig)}>Atrás</Button>
                                <Button className="Button-Modal" style={{ flexGrow: 1 }} onClick={() => { setOpen(!open); setCookie('viewed_cookie_policy', 'ok'); window.location.href = window.location.href; }} value="true" type="select" id="focusAfterClose" onChange={handleSelectChange}>Guardar y salir</Button>
                            </div>
                        </ModalFooter>
                    </>
                }
            </Modal>
        </div>
    )
}

export default ModalCookies;

function CookieCheck(props) {
    const [enabled, setEnabled] = useState(props.startValue ?? false);

    return <div style={{ backgroundColor: "rgb(230 230 230)", marginTop: 10, padding: "10px 10px 10px 15px", display: "flex", flexDirection: "row", justifyContent: "center", borderRadius: 6 }}>
        <span style={{ flexGrow: 1 }}>{props.text}</span>
        {enabled && <FaCheckCircle style={{ height: "100%", width: 27, cursor: "pointer", opacity: (props.enabled !== false ? 1 : 0.5) }}
            onClick={() => { if (props.enabled !== false) { setEnabled(!enabled); if (props.onChange) props.onChange(!enabled) } }}></FaCheckCircle>}
        {!enabled && <FaCircle style={{ height: "100%", width: 27, cursor: "pointer", opacity: (props.enabled !== false ? 1 : 0.5) }}
            onClick={() => { if (props.enabled !== false) { setEnabled(!enabled); if (props.onChange) props.onChange(!enabled) } }}></FaCircle>}
    </div>;
}